import React from 'react';
import SliderWithInput from './SliderWithInput.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import 'lodash';
import './Label.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../InfoIcon-d7b1bb17.js';
import '../Icons/InfoIcon.js';
import './Slider.js';
import 'classnames';
import '../consts.js';
import 'wix-rich-content-common';

var css_248z = ".-JLmF{width:270px}";
var styles = {"sliderPanel":"-JLmF"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SliderPanel = (props) => {
  const _a = props, {
    getValue,
    onChange,
    mapStoreDataToPanelProps,
    getEditorBounds,
    languageDir
  } = _a, otherProps = __objRest(_a, [
    "getValue",
    "onChange",
    "mapStoreDataToPanelProps",
    "getEditorBounds",
    "languageDir"
  ]);
  const mappedProps = __spreadValues(__spreadValues({}, otherProps), mapStoreDataToPanelProps == null ? void 0 : mapStoreDataToPanelProps(otherProps));
  return /* @__PURE__ */ React.createElement("div", { className: styles.sliderPanel, "data-hook": "sliderPanel" }, /* @__PURE__ */ React.createElement(
    SliderWithInput,
    __spreadProps(__spreadValues({}, mappedProps), {
      languageDir,
      defaultValue: getValue(props),
      onChange: onChange(__spreadProps(__spreadValues({}, props), { getEditorBounds })),
      sliderDataHook: "sliderPanel_Slider",
      inputDataHook: "sliderPanel_Input"
    })
  ));
};

export { SliderPanel as default };
//# sourceMappingURL=SliderPanel.js.map
